import { storage } from "@/core";
import { generateId } from "@msuite/katana";
import { Spinner } from "@msuite/picasso";
import { getDownloadURL, ref } from "firebase/storage";
import { type FC, useEffect, useState } from "react";

/** Props Interface */
interface QuestionImageProps {
	filePath: string | undefined;
}

export const QuestionImage: FC<QuestionImageProps> = ({ filePath }) => {
	/** State */
	const [imageUrl, setImageUrl] = useState<string | null>(
		sessionStorage.getItem(filePath || generateId()) ?? null,
	);

	/** Effects */
	useEffect(() => {
		async function fetchUrl() {
			if (!filePath) return;
			const cachedUrl = sessionStorage.getItem(filePath);
			if (cachedUrl) {
				setImageUrl(cachedUrl);
				return;
			}
			const storageRef = ref(storage, filePath);
			const downloadUrl = await getDownloadURL(storageRef);
			sessionStorage.setItem(filePath, downloadUrl);
			if (!downloadUrl) return;
			setImageUrl(downloadUrl);
		}

		fetchUrl();
	}, [filePath]);

	if (!imageUrl) return <Spinner />;

	return (
		<img
			src={imageUrl}
			alt="placeholder"
			style={{
				width: "100%",
				height: "100%",
				objectFit: "cover",
			}}
		/>
	);
};
